<template>
    <v-dialog name="editRow" v-model="level.dialogValues.dialogShow" data-app="true" persistent max-width="680">

         <v-card>

         <CardUpdatableHeader :row="row" :level="level"/>

        <v-form v-model="isFormValid">
         <v-card-text>
            <v-container>
               <v-row>
                  <v-col>
                     <v-text-field v-model="row.dkr_domainname" :disabled="level.dialogValues.form_disabled" outlined :label="$t('texts.dkr_domainname')" :rules="level.dialogOptions.domainnameRules" required :hint="$t('hints.dkr_domainname')" :persistent-hint="!level.dialogValues.form_disabled">
                     </v-text-field>
                  </v-col>
               </v-row>
               <v-row>
                  <v-col>
                     <v-text-field v-model="row.dkr_selector" :disabled="level.dialogValues.form_disabled || !row.cus_can_change_dkim_selector" outlined :label="$t('texts.dkr_selector')" :rules="level.dialogOptions.codeRules" required :hint="$t('hints.dkr_selector')" :persistent-hint="!level.dialogValues.form_disabled">
                     </v-text-field>
                  </v-col>
               </v-row>
            </v-container>
            <small>*{{ $t('texts.requiredfield') }}</small>
         </v-card-text>
        </v-form>

         <CardUpdatableFooter :row="row" :level="level"/>

         </v-card>
    </v-dialog>

</template>

<script>
import ddoAlert from '@/components/ddoAlert.vue';
import CardUpdatable from '@/components/partials/CardUpdatable.vue';
import CardUpdatableHeader from '@/components/partials/CardUpdatableHeader.vue';
import CardUpdatableFooter from '@/components/partials/CardUpdatableFooter.vue';

export default {
   name: 'CardUpdatableDKIMDomain',
   extends: CardUpdatable,
   components: {
      ddoAlert,
      CardUpdatableHeader,
      CardUpdatableFooter
   },

   props: {
   },

   data: function () {
      return {
         boolFormValid: false,
      }
   },

   computed: {

      isFormValid: {
         get: function() {
            console.log('isFormValid, get, value='+this.boolFormValid);
            return this.boolFormValid;
         },
         set: function(newValue) {
            console.log('isFormValid, set, newValue='+newValue);
            this.boolFormValid = newValue;

            this.$emit('change_dialogValues',this.level.level,'disable_create',!newValue);
         }
      },
   }

}
</script>